/** The resume endpoint must finish before the client can receive its code.
 * Do not use a timer, blur, or visibility change as proof of callback delivery.
 */
export const startHandoff = (url: string): void => {
  window.location.replace(url);
};
